
















import { Component, Vue } from 'vue-property-decorator'
import { CommonModule } from './store/modules/common'
import { callAppFunc_getSomeParams, appFunc_senToken } from './utils/bridge'
import { getConfigToast } from '@/api'
@Component({
  name: 'App'
})
export default class App extends Vue {
  async created() {
    await this.getToken()
    this.getSomeData()
    this.getConfigToast()
  }

  async getSomeData() {
    const res = await callAppFunc_getSomeParams()
    console.log(res, 'getSomeData', '////////////////////////////')
    CommonModule.setAppVersion(res.versionName)
    CommonModule.setDeviceId(res.deviceId)
    CommonModule.setPlatform(res.platform)
  }

  async getToken() {
    const res = await appFunc_senToken()
    console.log(res, 'getToken', '////////////////////////////')
    CommonModule.setUserId(res.id)
    CommonModule.setToken(res.tokenForJs)
    CommonModule.setUserPhone(res.mobile)
    CommonModule.setUserName(res.name)
    CommonModule.setDeviceModel(res.devicemodel)
    CommonModule.setSysVersion(res.sysversion)
  }
  async getConfigToast() {
    const res = await getConfigToast()
    if (res.code == 1001) {
      let toastData: any = null
      res.data.forEach((Element: any) => {
        if (Element.type == 5) {
          toastData = Element
        }
      })
      if (toastData) {
        if (CommonModule.language == 'zh') {
          CommonModule.setDefaultToast('zh', toastData.content)
        } else {
          CommonModule.setDefaultToast('ug', toastData.uigContent)
        }
      }
    }
    console.log(res, 'toast', '////////////////////////////')
  }
}
